import { render, staticRenderFns } from "./HotList.vue?vue&type=template&id=01743b1b&scoped=true"
import script from "./HotList.vue?vue&type=script&setup=true&lang=ts"
export * from "./HotList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HotList.vue?vue&type=style&index=0&id=01743b1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01743b1b",
  null
  
)

export default component.exports